import React, { useEffect } from 'react';
import './scss/app.scss';
import { ThemeProvider } from "@mui/material/styles";
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { theme } from './constant';
import useLocation from './hooks/use-location';
import Router from './router/router';

function App() {
  const [location, hasPermission] = useLocation();
  let flag = localStorage.getItem('showPermissionAlert') || true;

  useEffect(() => {
    if (hasPermission) {
      localStorage.setItem("@Location", JSON.stringify(location));
    }
  }, [hasPermission, location]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&callback=Function.prototype&libraries=geometry,places`;
    script.type = 'text/javascript';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Router />
      {!hasPermission && flag ? <PermissionDialog open={!hasPermission} handleClick={() => { localStorage.setItem('showPermissionAlert', false); }} /> : null}
    </ThemeProvider>
  );
}

const PermissionDialog = ({ open, handleClick = () => { } }) => {
  return (
    <Box className={`permission_dialog ${open ? " show" : ""}`}>
      <Box sx={{ textAlign: "right", mb: -3 }}>
        <IconButton className='permission_dialog__button' onClick={handleClick} ><CloseIcon /></IconButton>
      </Box>
      <p className='permission_dialog__title' children="Location Permission" />
      <p className='permission_dialog__text'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
    </Box>
  )

}

export default App;
